import React from 'react';
import PropTypes from 'prop-types';
import { LinearProgress } from 'material-ui';
import { connect } from 'react-redux';
import { showNotification as showNotificationAction } from 'admin-on-rest';
import fetcher from '../helpers/fetcher';
import { URL_FILE_IMPORT } from '../constants.js';

class UploadedDataWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  _stopLoading = () => {
    this.setState({ loading: false });
  };

  _startLoading = () => {
    this.setState({ loading: true });
  };

  render() {
    return (
      <div style={{}}>
        {this.props.value && (
          <div>
            {(!this.props.value.filename || !this.props.value.projectId) && (
              <div>
                <i>Please load a xlsx or csv file</i>
              </div>
            )}
            {this.props.value.filename &&
              this.props.value.projectId && (
                <div>
                  {this.state.loading && <LinearProgress />}
                  <p>
                    The file "{this.props.value.filename}" was uploaded.
                    <span>
                      If the preview looks ok press on the button to import it
                    </span>
                  </p>
                  <button
                    className={`btn btn-primary`}
                    type="button"
                    disabled={this.state.loading}
                    onClick={() => {
                      const data = {
                        filename: this.props.value.filename,
                        project: this.props.value.projectId
                      };

                      const { newline, delimiter } = this.props.value;
                      if (newline) {
                        data.newline = newline;
                      }
                      if (delimiter) {
                        data.delimtier = delimiter;
                      }

                      this._startLoading();
                      fetcher
                        .post(URL_FILE_IMPORT, data)
                        .then(res => {
                          this._stopLoading();
                          if (this.props.onChange) {
                            this.props.onChange({
                              ...this.props.value,
                              imported: true
                            });
                          }
                          this.props.showNotification(
                            'Data was imported successfully'
                          );
                        })
                        .catch(err => {
                          this.props.showNotification(
                            'Error while importing data',
                            'warning'
                          );
                          this._stopLoading();
                        });
                    }}
                  >
                    Import
                  </button>
                </div>
              )}
          </div>
        )}
        {!this.props.value && <div>No value yet</div>}
      </div>
    );
  }
}

UploadedDataWidget.propTypes = {
  value: PropTypes.shape({
    filename: PropTypes.string,
    projectId: PropTypes.number,
    newline: PropTypes.string,
    delimiter: PropTypes.string
  }),
  onChange: PropTypes.func,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification: showNotificationAction
})(UploadedDataWidget);



// WEBPACK FOOTER //
// ./src/components/UploadedDataWidget.js